import Card from 'components/card';
import { MdClose } from 'react-icons/md';

const SuccessModal = (props: { isOpen: any; onClose: any }) => {
    const { isOpen, onClose } = props;

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/30 backdrop-blur-sm transition-opacity">
            <div className="relative z-[1002] w-full max-w-[500px] p-4">
                <Card extra="px-[30px] pt-[35px] pb-[40px] w-full flex flex-col !z-[1004] min-h-[250px] border shadow-2xl">
                    <div className="absolute right-5 top-5">
                        <MdClose
                            size={20}
                            className="cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
                            onClick={onClose}
                        />
                    </div>
                    <p className="text-center text-xl font-bold text-navy-700 dark:text-white">
                        Offre déposée 🎉
                    </p>
                    <p className="text-md mt-6 text-center text-gray-600 dark:text-gray-300">
                        Nous vous remercions d'avoir déposé une nouvelle
                        annonce de leads. Nous reviendrons vers vous
                        dans les plus brefs délais pour vérifier la
                        faisabilité de votre demande.
                    </p>
                    <p className="mt-6 flex justify-center font-medium text-navy-700 dark:text-white">
                        L’équipe Leadrs
                    </p>
                </Card>
            </div>
        </div>
    );
};
export default SuccessModal;
